import { ValueType } from '../FormatterTypes';
import { IInternalDateFormat } from '../Displayers/TEDCustomDateTimeDisplayer';
import moment from 'moment';
import { padToLength } from '../../stringUtils';
import { getDaysInMonth } from '../../dateUtils';

const MIN_YEAR = 100;
const MAX_YEAR = 9999;

// DateTime helpers
/** @deprecated */
export const extractDate = (
  value: ValueType,
  params: string,
  defaultParams: string
): Date => {
  let date: Date;
  if (typeof value === 'string') {
    const dateRegExpPos = {
      year: 1,
      month: 2,
      day: 3,
    };

    const timeRegExpPos = {
      hour: 1,
      minute: 2,
      second: 3,
    };
    // Date might be there, might not...
    let tempValue = value;

    // RegExp för att hitta ett datum.
    const dateReg = /^(\d{2,4})-(\d{1,2})?-?(\d{2})?/;
    // RegExp för att hitta en tid.
    const timeReg =
      /^(2[0-3]|1[0-9]|[0-9]|0[0-9]):?(0[0-9]|[0-5][0-9])?:?([0-5][0-9])?$/;

    const regDate = dateReg.exec(tempValue);
    // Remove the date if we matched that part of the string
    tempValue =
      regDate && regDate[0]
        ? tempValue.slice(regDate[0].length).trim()
        : tempValue;
    const regTime = timeReg.exec(tempValue);

    let dateString = '';
    if (regDate) {
      dateString += `${regDate[dateRegExpPos.year]}-${
        regDate[dateRegExpPos.month]
      }-${regDate[dateRegExpPos.day]}`;
    } else {
      dateString += '1899-12-30'; // assume 0 (as in delphi)
    }

    let timeString = '';

    if (regTime && tempValue.length > 0) {
      const hour = regTime[timeRegExpPos.hour] || '00';
      const minute = regTime[timeRegExpPos.minute] || '00';
      const second = regTime[timeRegExpPos.second] || '00';
      timeString += `${hour}:${minute}:${second}`;
    } else {
      timeString += '00:00:00';
    }

    // Treat the time as UTC.
    date = new Date(dateString + 'T' + timeString + 'Z');
  } else if (typeof value === 'number') {
    date = getDateFromNumber(value);
  } else {
    throw new Error('asDateTime supplied a boolean value');
  }

  return date;
};

/** @deprecated */
export const getDateFromNumber = (value: number): Date => {
  // Det här testfallet failar, för avrundningsfel, får rätt dag, men kl 14:45
  // {
  //     "description": "can interpret a real date and time",
  //     "formatter": "TEDFormatDateTimeGeneral",
  //     "value": 43311.6145833333,
  //     "params": "Format=\"yyyy-mm-dd hh:nn\"",
  //     "expectedValue": "2018-07-30 14:45"
  //   },
  let dateNumber = Number.parseInt(String(value), 10);
  let timeNumber = Math.abs(value - dateNumber);
  dateNumber *= 24 * 60 * 60 * 1000;
  timeNumber *= 24 * 60 * 60 * 1000;

  let dateTime =
    new Date('1899-12-30T00:00Z').valueOf() + dateNumber + timeNumber;
  return new Date(dateTime);
};

/** @deprecated */
export const extractDateString = (value: number, dateSep: string): string => {
  const date = getDateFromNumber(value);
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth() + 1;
  const day = date.getUTCDate();

  return `${year}${dateSep}${month}${dateSep}${day}`;
};

/** @deprecated */
export const getMonthText = (
  month: number,
  shortText: boolean = false
): string => {
  if (month < 1 || month > 12) {
    throw new Error('Wrong month supplied to getMonthText');
  }
  const months: Record<number, string[]> = {
    1: ['januari', 'jan'],
    2: ['februari', 'feb'],
    3: ['mars', 'mar'],
    4: ['april', 'apr'],
    5: ['maj', 'maj'],
    6: ['juni', 'jun'],
    7: ['juli', 'jul'],
    8: ['augusti', 'aug'],
    9: ['september', 'sep'],
    10: ['oktober', 'okt'],
    11: ['november', 'nov'],
    12: ['december', 'dec'],
  };

  const index = shortText ? 1 : 0;
  return months[month][index];
};

/** @deprecated */
export const getWeekDayText = (
  day: number,
  shortText: boolean = false
): string => {
  if (day < 1 || day > 7) {
    throw new Error('Wrong weekday supplied to getWeekDayText');
  }
  const weekDay: Record<number, string[]> = {
    1: ['måndag', 'må'],
    2: ['tisdag', 'ti'],
    3: ['onsdag', 'on'],
    4: ['torsdag', 'to'],
    5: ['fredag', 'fr'],
    6: ['lördag', 'lö'],
    7: ['söndag', 'sö'],
  };

  const index = shortText ? 1 : 0;
  return weekDay[day][index];
};

/** @deprecated */
export const getQuarterMonth = (quarter: number): number => {
  if (quarter < 1 || quarter > 4) {
    throw new Error('Invalid Quarter supplied to getQuarterMonth');
  }

  return quarter * 3 - 2;
};

/** @deprecated */
export const weekNrToDate = (AYear: number, AWeekNo: number) => {
  if (AWeekNo < 0 || AWeekNo > 53) {
    throw new Error(`Invalid week ${AWeekNo} supplied to weekNrToDate`);
  }
  const result = moment(
    moment(AYear).startOf('year').valueOf() + (AWeekNo - 1) * 7
  );
  if (result.isSameOrAfter(moment(AYear + 1).startOf('year'))) {
    throw new Error(`The year ${AYear} has no week ${AWeekNo}`);
  }

  return result;
};

/** @deprecated */
export const tryEncodeDateString = (d: IInternalDateFormat): string | null => {
  const condition =
    d.ty <= MAX_YEAR &&
    d.tm <= 12 &&
    d.td <= 31 &&
    (d.ty >= 0 || (d.tm < 0 && d.td <= 0)) &&
    (d.tm >= 0 || d.td < 0) &&
    (d.ty >= MIN_YEAR || (d.tm < 1 && d.td < 1)) &&
    (d.tm >= 1 || d.td < 1) &&
    (d.td <= 28 || d.td <= getDaysInMonth(d.ty, d.tm));

  if (!condition || d.ty < 0) {
    return null;
  }
  const year = padToLength(d.ty, 4, '0');
  if (d.tm < 0) {
    return year;
  }
  const month = padToLength(d.tm, 2, '0');
  if (d.td < 0) {
    return `${year}${month}`;
  }
  const day = padToLength(d.td, 2, '0');
  return `${year}${month}${day}`;
};

/** @deprecated */
export const tryEncodeDateTimeString = (
  d: IInternalDateFormat
): string | null => {
  const encodeDate = tryEncodeDateString(d);
  if (encodeDate) {
    if (d.tm > 0 && d.td > 0) {
      if (d.th <= 23 && d.th >= 0 && d.tn <= 59 && d.tn >= 0) {
        const hour = padToLength(d.th, 2, '0');
        const minute = padToLength(d.tn, 2, '0');
        return `${encodeDate}${hour}${minute}`;
      }

      return encodeDate;
    } else {
      if (d.th < 0 && d.tn < 0) {
        return encodeDate;
      }

      return null;
    }
  }

  return null;
};

/** @deprecated */
export const encodeDate = (d: IInternalDateFormat): Date | null => {
  if (d.tm < 1 || d.tm > 12 || d.td < 1 || d.td > 31) {
    return null;
  }

  let date = new Date(
    `${d.ty}/${d.tm}/${d.td} ${d.th !== -1 ? d.th : 0}:${
      d.tn !== -1 ? d.tn : 0 || 0
    }:${d.ts !== -1 ? d.ts : 0 || 0}`
  );
  return date;
};

/** @deprecated */
export const encodeTime = (
  d: IInternalDateFormat,
  baseDate?: Date
): Date | null => {
  if (d.th < 24 && d.tn < 60 && d.ts < 60 && d.tms < 1000) {
    const date = baseDate ?? new Date();
    date.setHours(d.th);
    date.setMinutes(d.tn);
    date.setSeconds(d.ts);
    date.setMilliseconds(d.tms);

    return date;
  }

  return null;
};

/** @deprecated */
export const getWeekNr = (d: Date): { year: number; week: number } => {
  // !!!Stolen from stack overflow!!!

  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  // Get first day of year
  let yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  // Calculate full weeks to nearest Thursday
  let weekNo = Math.ceil(
    ((d.valueOf() - yearStart.valueOf()) / 86400000 + 1) / 7
  );
  // Return array of year and week number
  return { year: d.getUTCFullYear(), week: weekNo };
};

/** @deprecated */
export const getQuarterText = (month: number): string => {
  const quarterNames = ['vår', 'sommar', 'höst', 'vinter'];

  return quarterNames[getQuarter(month)];
};

/** @deprecated */
export const getQuarter = (month: number): number => {
  if (!Number.isInteger(month) || month < 1 || month > 12) {
    throw new Error('getQuarter supplied with erronious month: ' + month);
  }

  return Math.floor((month + 2) / 3);
};

// export const matchPattern = (
//   s: string,
//   pattern: string,
//   validSeps: string,
// ): { result: boolean; value: string } => {
//   const result = { result: false, value: '' };
//   let index = 0;
//   while(index < pattern.length){
//     const current = pattern[index];
//     let group: RegExpMatchArray|null = null;
//     let subMatch = { result: false, value: '' };
//     switch(current){
//       case '#':
//         result.value += '[0-9]';
//         index ++;
//         break;
//       case '.':
//         result.value += '-';
//         index ++;
//         break;
//       case '0':
//       case '1':
//       case '2':
//       case '3':
//       case '4':
//       case '5':
//       case '6':
//       case '7':
//       case '8':
//       case '9':
//         if(pattern.length <= index+1 && pattern[index+1]===':'){
//           index += 2;
//         }
//         else{
//           group = pattern.slice(index).match(/([0-9])([-,])([0-9])#/);
//           if(group && group[1] && group[2] && group[3]){
//             if(group[2] === '-'){
//               pattern += `[0-9]{${group[1]},${group[3]}}`;
//             }
//             index += 3;
//           }
//         }
//         break;
//       case '(':
//         group = s.slice(index).match(/\(  \)/);
//         if(group && group[1])
//           subMatch = matchPattern(s, group[1], validSeps);
//           index += group[0].length;
//         }
//         else {
//           return { result: false, value: '' };
//         }
//         break;
//     }

//   }

//   return result;
// };
